import { useState } from 'react';
import { useMutation, useQueryClient } from '@tanstack/react-query';
import { Box, Button } from '@mui/material';
import { orderService } from '@resort-os/api-client';
import { useFormatCurrency, useCurrency, useSnackbar } from '@resort-os/ui';

const BORDER = '1px solid #E2DDD8';
const ACCENT = '#2C3E2D';

export default function DiscountSection({ orderId }: { orderId: string }) {
  const queryClient = useQueryClient();
  const { showSnackbar } = useSnackbar();
  const formatCurrency = useFormatCurrency();
  const { currency } = useCurrency();
  const [discountType, setDiscountType] = useState<'percentage' | 'fixed'>('percentage');
  const [discountValue, setDiscountValue] = useState('');
  const [showDiscount, setShowDiscount] = useState(false);

  const discountMutation = useMutation({
    mutationFn: (data: { discount_type: string; value: number }) =>
      orderService.applyDiscount(orderId, data),
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: ['orders'] });
      showSnackbar('Discount applied', 'success');
      setShowDiscount(false);
      setDiscountValue('');
    },
    onError: (err: any) => showSnackbar(err?.response?.data?.error || 'Failed', 'error'),
  });

  if (!showDiscount) {
    return (
      <Button
        size="small"
        onClick={() => setShowDiscount(true)}
        sx={{
          fontSize: '0.72rem',
          color: ACCENT,
          textTransform: 'none',
        }}
      >
        + Apply Discount
      </Button>
    );
  }

  return (
    <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, flexWrap: 'wrap' }}>
      <select
        value={discountType}
        onChange={e => setDiscountType(e.target.value as any)}
        style={{
          fontSize: '0.72rem',
          padding: '4px 8px',
          border: BORDER,
          borderRadius: 0,
          background: '#FFF',
          height: 32,
        }}
      >
        <option value="percentage">%</option>
        <option value="fixed">{currency?.code || 'KES'}</option>
      </select>
      <input
        type="number"
        placeholder="Value"
        value={discountValue}
        onChange={e => setDiscountValue(e.target.value)}
        style={{
          width: 80,

          fontSize: '0.72rem',
          padding: '4px 8px',
          border: BORDER,
          borderRadius: 0,
          height: 32,
        }}
        min="0"
      />
      <Button
        size="small"
        disabled={!discountValue || discountMutation.isPending}
        onClick={() =>
          discountMutation.mutate({ discount_type: discountType, value: Number(discountValue) })
        }
        variant="contained"
        sx={{
          bgcolor: ACCENT,
          borderRadius: 0,
          fontSize: '0.7rem',

          minWidth: 60,
          height: 32,
        }}
      >
        {discountMutation.isPending ? '...' : 'Apply'}
      </Button>
      <Button
        size="small"
        onClick={() => setShowDiscount(false)}
        sx={{
          fontSize: '0.7rem',
          color: '#9B958F',
          textTransform: 'none',
          minWidth: 40,
        }}
      >
        ✕
      </Button>
    </Box>
  );
}
